import { useState, useCallback, useMemo } from 'react'
import useServiceDependenciesResources from '../../shared/resources/api/v1/admin/docker/useServiceDependenciesResources'
import useServicesResources from '../../shared/resources/api/v1/admin/docker/useServicesResources'

export default function useServiceDependenciesState(teamSlug, projectSlug, serviceSlug, serviceId) {
  const [dependencies, setDependencies] = useState([])
  const [loading, setLoading] = useState(true)
  const [allServices, setAllServices] = useState([])

  const {
    all: fetchDependencies,
    create,
    destroy,
  } = useServiceDependenciesResources(teamSlug, projectSlug, serviceSlug)

  const { all: fetchAllServices } = useServicesResources(teamSlug, projectSlug)

  const load = useCallback(() => {
    const dependenciesPromise = fetchDependencies()
      .then((response) => setDependencies(response.serviceDependencies || []))
      .catch(() => setDependencies([]))

    const servicesPromise = fetchAllServices()
      .then((response) => setAllServices(response.services || []))
      .catch(() => setAllServices([]))

    return Promise.all([dependenciesPromise, servicesPromise])
      .finally(() => setLoading(false))
  }, [fetchDependencies, fetchAllServices])

  const refresh = useCallback(() => {
    return fetchDependencies()
      .then((response) => setDependencies(response.serviceDependencies || []))
      .catch(() => setDependencies([]))
  }, [fetchDependencies])

  const createDependency = useCallback((data) => {
    return create(data).then(() => refresh())
  }, [create, refresh])

  const destroyDependency = useCallback((id) => {
    return destroy(id).then(() => refresh())
  }, [destroy, refresh])

  const availableServices = useMemo(() => {
    return allServices.filter((s) => {
      if (s.id === serviceId) return false
      return !dependencies.some((d) => d.dependsOnServiceId === s.id)
    })
  }, [allServices, dependencies, serviceId])

  return {
    dependencies,
    loading,
    availableServices,
    load,
    createDependency,
    destroyDependency,
  }
}
